import { dynamicLoader } from '~/utils';

export const AdminPage = dynamicLoader({
  name: 'AdminPage',
  importFunc: () => import('./admin'),
});